import {BASE_PATH, BASE_PATH_EXTENSION} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/organization`;

export async function getApiOrganizationSearch() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/search`, config)
}

export async function getApiOrganizationCreate(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}

export async function getApiOrganizationUpdate(organization_id, props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/update/${organization_id}`, props, config)
}

export async function apiOrganizationUpdateVerifactu(organization_id, props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/update-verifactu/${organization_id}`, props, config)
}

export async function getApiOrganizationDelete(organization_id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.delete(`${urlBase}/delete/${organization_id}`, config)
}

export async function getApiOrganizationAddUser(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/add-user`, props, config)
}

export async function getApiOrganizationRemoveUser(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/remove-user`, props, config)
}

export async function getApiOrganizationSearchUsers(organization_id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/search-users/${organization_id}`, config)
}

export async function getApiOrganizationDetails() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/details`, config)
}